import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var BackpanelView = /** @class */ (function (_super) {
    tslib_1.__extends(BackpanelView, _super);
    function BackpanelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moveNextPrevented = false;
        _this.moveNextTimer = null;
        return _this;
    }
    BackpanelView.prototype.moveNext = function () {
        this.moveNextPrevented = true;
        var self = this;
        this.moveNextTimer = setTimeout(function () { return self.moveNextPrevented = false; }, 3000);
    };
    BackpanelView.prototype.mounted = function () {
        this.$state.mode = "backpanel";
    };
    BackpanelView = tslib_1.__decorate([
        Component
    ], BackpanelView);
    return BackpanelView;
}(Vue));
export default BackpanelView;
